/**
 * 蟑螂預製物件
 * 代表遊戲中的蟑螂角色，包含移動動畫和行為邏輯
 */
export default class Cockroach extends Phaser.Sprite {

  /**
   * 創建蟑螂實例
   * @param {Phaser.Game} game - Phaser遊戲實例
   * @param {number} x - 初始X座標
   * @param {number} y - 初始Y座標
   * @param {string} type - 蟑螂類型（對應不同的精靈表）
   */
  constructor(game, x, y, type) {
    super(game, x, y, type, 0);

    this.inputEnabled = true;

    // 設置隨機縮放比例
    this.frac = this.game.rnd.frac();
    this.scale.set(this.frac, this.frac);

    // 設置爬行動畫
    this.setupAnimation();
  }

  /**
   * 設置爬行動畫
   * 使用精靈表的幀創建循環動畫
   */
  setupAnimation() {
    const crawlFrames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.crawlAnimation = this.animations.add("crawl", crawlFrames);
    this.animations.play("crawl", 16, true);
  }

  /**
   * 更新循環
   * 處理蟑螂的移動邏輯，包括垂直和水平移動
   */
  update() {
    // 垂直移動：根據縮放比例調整移動速度
    const moveSpeed = this.frac > 0.3
      ? Math.random() * this.frac * 10
      : Math.random() * 10;
    this.y -= moveSpeed;

    // 當蟑螂移出螢幕頂部時，重置到底部
    if (this.y < -300) {
      this.y = this.game.world.height + 300;
    }

    // 水平移動：使用正態分佈產生自然的左右搖擺效果
    this.x -= this.game.rnd.normal() * 1;
  }
}